import { atom } from "@reatom/framework";

export const selectedProductAtom = atom(0, "selectedProduct");
